import ResearchLineCard from '../Cards/ResearchLineCard'
import { faComputer, faDatabase, faMagnifyingGlassChart } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';
import { RESEARCH_PROJECTS } from '../../routes';

const ResearchLines = ({researchLineRef}) => {

    const translationPrefix = 'Research';
    const { t } = useTranslation('global');

    return (
        <section ref={researchLineRef} className="md:py-2 py-24 md:px-4 lg:px-16">
  
            <div className="flex flex-wrap items-center">
              <div className="w-10/12 md:w-6/12 lg:w-4/12 px-12 md:px-1 mr-auto ml-auto">
                <div className="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-blueGray-700">
                  <img
                    alt="..."
                    src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
                    className="w-full align-middle rounded-t-lg"
                  />
                  <blockquote className="flex flex-col relative p-8 mb-4">
                    <svg
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 583 95"
                      className="absolute left-0 w-full block h-95-px -top-94-px"
                    >
                      <polygon
                        points="-30,95 583,95 583,65"
                        className="text-blueGray-700 fill-current"
                      ></polygon>
                    </svg>
                    <h4 className="text-xl font-bold text-white">
                      {t(`${translationPrefix}.research_lines`)}
                    </h4>
                    <p className="text-md font-light mt-2 text-white">
                      {t(`${translationPrefix}.description`)}
                    </p>
                    <a
                      href={RESEARCH_PROJECTS}
                      className="pt-4 font-bold text-white hover:underline ease-linear transition-all duration-150"
                    >
                      { t(`${translationPrefix}.research_projects`) + " "}
                      <i className="fa fa-angle-double-right ml-1 leading-relaxed"></i>
                    </a>
                  </blockquote>
                </div>
              </div>
              
              {/* ---------- RESEARCH LINES -------------- */}
              <div className="w-full md:w-6/12 px-4">
                <div className="flex flex-wrap">
                  <div className="w-full md:w-6/12 px-4">
                    <ResearchLineCard icon={faDatabase} margin={true} title={t(`${translationPrefix}.research_line_1.name`)} description={t(`${translationPrefix}.research_line_1.description`)} />
                    <ResearchLineCard icon={faComputer} title={t(`${translationPrefix}.research_line_2.name`)} margin={false} description={t(`${translationPrefix}.research_line_2.description`)} />
                  </div>
                  <div className="w-full md:w-6/12 px-4">
                    <ResearchLineCard icon={faMagnifyingGlassChart} margin={true} title={t(`${translationPrefix}.research_line_3.name`)} description={t(`${translationPrefix}.research_line_3.description`)} />
                  </div>
                </div>
              </div>
            </div>

        </section>
    )
}

export default ResearchLines;